'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/core-base.prod.cjs')
} else {
  module.exports = require('./dist/core-base.cjs')
}
